<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" md="10" offset-md="1" lg="8" offset-lg="2" xl="6">
        <template v-if="showSkeleton">
          <v-skeleton-loader
            class="mb-6"
            type="card-avatar, article, list-item-avatar, list-item-avatar"
          ></v-skeleton-loader>
        </template>
        <template v-if="!showSkeleton && profile != null">
          <v-row>
            <v-col cols="12" lg="4">
              <v-sheet elevation="2" rounded>
                <div class="pa-4">
                  <v-row no-gutters align="center">
                    <v-col cols="12">
                      <div class="text-center">
                        <v-avatar :size="100">
                          <v-img :src="profile.info.image"></v-img>
                        </v-avatar>
                      </div>
                    </v-col>
                    <v-col cols="12">
                      <div class="text-center">
                        <div class="subtitle-1">{{ profile.info.displayName }}</div>
                        <div v-text="profile.info.email"></div>
                      </div>
                      <v-divider class="my-4"></v-divider>
                      <v-row align="center">
                        <v-col cols="12" class="align-self-center pr-2">
                          <v-icon small class="fa-fw mr-2">far fa-eye</v-icon>
                          {{ profile.allViewCountOwner | localeNumber }} Viewed
                        </v-col>
                        <v-col cols="12" class="align-self-center pr-2">
                          <v-icon small class="fa-fw mr-2">fas fa-users-class</v-icon>
                          {{ profile.allCountMyLibOwner | localeNumber }} Student
                        </v-col>
                        <v-col cols="12" class="align-self-center pr-2">
                          <v-icon small class="fa-fw mr-2">fas fa-play-circle</v-icon>
                          {{ profile.courseOwnerCount | localeNumber }} Courses
                        </v-col>
                        <v-col cols="12" class="align-self-center">
                          <div class="d-flex">
                            <div>
                              <v-rating
                                half-increments
                                half-icon="fas fa-star-half-alt"
                                background-color="grey"
                                color="amber"
                                readonly
                                dense
                                small
                                :value="profile.avgRating"
                              ></v-rating>
                            </div>

                            <div class="mt-1 mx-1 body-2">
                              <span
                                class="text-uppercase text--secondary caption"
                              >({{ profile.avgRating | numFormat('0.00') }})</span>
                            </div>
                          </div>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </div>
              </v-sheet>
              <v-sheet elevation="2" rounded class="my-4">
                <div>
                  <v-subheader>Quick Menu</v-subheader>
                  <v-list dense class="list-menu">
                    <v-list-item link :to="{name: 'my_course'}">
                      <v-list-item-icon>
                        <v-icon class="fa-fw">far fa-books</v-icon>
                      </v-list-item-icon>
                      <v-list-item-title>My Course</v-list-item-title>
                    </v-list-item>
                    <v-list-item link :to="{name: 'wishlist'}">
                      <v-list-item-icon>
                        <v-icon class="fa-fw">far fa-heart</v-icon>
                      </v-list-item-icon>
                      <v-list-item-title>Wish List</v-list-item-title>
                    </v-list-item>
                    <v-list-item link :to="{name: 'profile'}">
                      <v-list-item-icon>
                        <v-icon class="fa-fw">far fa-address-card</v-icon>
                      </v-list-item-icon>
                      <v-list-item-title>Profile</v-list-item-title>
                    </v-list-item>
                    <v-list-item link :to="{name: 'portfolio'}">
                      <v-list-item-icon>
                        <v-icon class="fa-fw">far fa-images</v-icon>
                      </v-list-item-icon>
                      <v-list-item-title>Portfolio</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </div>
              </v-sheet>
            </v-col>
            <v-col cols="12" lg="8">
              <timeline-poster ref="poster"></timeline-poster>

              <v-sheet class="pa-2" rounded elevation="1">
                <div class>
                  <a
                    class="text-decoration-none info--text d-flex pa-2 align-center"
                    @click="$refs.poster.open()"
                    style="width: 100%;"
                  >
                    <v-icon color="info" left>far fa-edit</v-icon>
                    <span class="body-1">Start a post</span>
                  </a>
                </div>
              </v-sheet>

              <section class="timeline-items my-4">
                <timeline-item :items="portfolio"></timeline-item>
              </section>
            </v-col>
          </v-row>
        </template>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import CourseVerticalGridView from "@/components/CourseVerticalGridView.vue";
import TimelinePoster from "@/components/TimelinePoster.vue";
import TimelineItem from "@/components/TimelineItem.vue";
import Vue from 'vue';

export default {
  components: {
    CourseVerticalGridView,
    TimelinePoster,
    TimelineItem,
  },
  data: () => ({
    showSkeleton: true,
    portfolio: [],
    allowPost: false,
    loading: false,
    profile: null,
  }),
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.fetch();
      // sample test
      this.portfolio = this.genSample();
    },
    genSample() {
      let samples = [];
      let sample1 = {
        text: "Test message",
        type: "gallery",
        content: [],
        liked: 6,
      };
      for (let i = 0; i < 15; i++) {
        sample1.content.push(
          `https://picsum.photos/500/300?image=${i * 5 + 10}`
        );
      }
      samples.push(sample1);
      samples.push({
        text: "รอยยิ้มที่หัวใจ - ETC",
        type: "youtube",
        content: "https://www.youtube.com/watch?v=9xT-LuElxec",
        liked: 0,
      });

      return samples;
    },
    fetch() {
      this.profile = null;
      this.showSkeleton = true;
      const userInfo = Vue.prototype.$userInfo;
      this.$http
        .get(
          `${this.$store.state.api}/account/profile/teacher?id=${userInfo._id}`
        )
        .then((resp) => {
          if (resp.data.status == true) {
            this.profile = resp.data.result;
          } else {
            this.profile = null;
          }
        })
        .catch((err) => {
          this.profile = null;
        })
        .finally(() => {
          this.showSkeleton = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.post-container {
  border: 1px solid rgb(218, 218, 218);
}
</style>